// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Ajt3","notes":"Notes_notes__1vQ9j"};